import useToken from '@plug-core/hooks/useToken'
import { EarnPosition } from '@plug-core/interfaces/earn'
import { formatMoney } from '@plug-core/utils/formatNumber'
import { titleize } from '@plug-core/utils/titleize'
import { ListRow, Text } from '@ui'
import React, { FC } from 'react'
import { Tag, TokenWithChain } from './shared'

interface Props {
  position: EarnPosition
  onClick?: (position: EarnPosition) => void
}

export const PositionListItem: FC<Props> = ({ position, onClick }) => {
  const token = useToken({ address: position.asset.address, chain: position.chainId })

  return (
    <ListRow
      onClick={onClick ? () => onClick(position) : undefined}
      leading={
        <TokenWithChain
          logo={token.logo}
          fallbackName={position.asset.symbol}
          chainId={position.chainId}
        />
      }
      primary={position.asset.name}
      secondary={
        <span className="mt-0.5 flex gap-1">
          <Tag>{titleize(position.protocolName)}</Tag>
        </span>
      }
      trailing={
        <Text
          as="span"
          variant="body-s"
          weight="semibold"
          tone="fg"
          tabular
          className="min-w-[86px] text-right"
        >
          {formatMoney(Number(position.balanceUsd))}
        </Text>
      }
    />
  )
}
